export const GET_TOTAL_STATS = 'CDL/get_total_stats';
export const GET_GRAPH_STATS = 'CDL/get_graph_stats';

export const LEGENDS = [
    { name: 'OVR PAYMENT', color: '#A3B3F9', value: 0 },
];